import { Button } from '@/components/ui/button';
import { AlertTriangle, X, Check } from 'lucide-react';

const ChallengeRulesModal = ({ onAccept, onClose }) => {
  const rules = [
    'Record vertically (9:16) for the best share quality',
    'Submit your real, honest score',
    'Multiple attempts are allowed — only your best counts',
    'Meybra may review suspicious submissions',
    'Scores that don\'t match the video may be removed from the ranking',
    'Repeated abuse may result in challenge disqualification',
  ];

  return (
    <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4" data-testid="challenge-rules-modal">
      <div className="bg-card border border-amber-500/40 rounded-sm max-w-lg w-full p-6 relative">
        <button onClick={onClose} className="absolute top-4 right-4 text-muted-foreground hover:text-foreground">
          <X size={20} />
        </button>
        <div className="text-center mb-6">
          <div className="w-14 h-14 bg-amber-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
            <AlertTriangle className="text-amber-400" size={28} />
          </div>
          <h2 className="font-heading text-xl uppercase mb-2">Challenge Rules</h2>
          <p className="text-muted-foreground text-sm">Quick read before you compete.</p>
        </div>
        <ul className="space-y-3 mb-6">
          {rules.map((r, i) => (
            <li key={i} className="flex items-start gap-3 text-sm">
              <Check size={16} className="text-primary mt-0.5 flex-shrink-0" />
              <span>{r}</span>
            </li>
          ))}
        </ul>
        <Button
          onClick={onAccept}
          className="w-full bg-primary text-black hover:bg-primary/90 uppercase tracking-wider font-bold h-12"
          data-testid="rules-understand-btn"
        >
          I Understand — Let's Go
        </Button>
      </div>
    </div>
  );
};

export default ChallengeRulesModal;
